<template>
  <div v-cloak class="animated fadeIn">
    <h1 class="mb-4">EIB counterparts</h1>
    <div class="card">
      <div class="card-header bg-transparent">
        <div
          class="d-flex justify-content-between align-items-center flex-nowrap"
        >
          Counterparts
          <file-dragdrop
            title="Select a document file to upload"
            label="Upload"
            @upload="
              (files) =>
                $uploadFile({
                  fileId: 2,
                  file: files[0],
                  onProgress: (progress) => onProgress(progress),
                })
            "
            v-if="!progressValue"
          >
          </file-dragdrop>
          <CProgress
            v-else
            :value="progressValue"
            animated
            showPercentage
            class="w-50"
          />
        </div>
        <hr />
      </div>
      <div class="card-body">
        <table-component
          :columns="['filename', 'date', 'nb_of_lines', 'actions']"
          :data="docs"
        >
          <template slot="nb_of_lines" slot-scope="{ row }">
            <span class="float-right">{{ row.nb_of_lines }}</span>
          </template>
          <template slot="filename" slot-scope="{ row }">
            <span
              class="link pointer"
              @click="
                $downloadFile({
                  name: row.filename,
                  fileId: 2,
                  url: `${BASE_URL}api/files/download/`,
                })
              "
            >
              {{ row.filename }}
            </span>
          </template>
          <template slot="actions" slot-scope="{ row }">
            <a
              @click="() => deleteFile(row.filename, 2)"
              class="btn btn-outline-danger"
            >
              <i class="fa fa-trash-o"></i>
            </a>
          </template>
        </table-component>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import { BASE_URL } from "@/constants/config";

export default {
  name: "Counterparts",
  data: function () {
    return {
      BASE_URL,
      progressValue: null,
      docs: [],
    };
  },
  mounted() {
    this.getDocs();
  },
  methods: {
    async getDocs() {
      const { data, res } = await this.$request({
        url: `${this.BASE_URL}api/overview/counterparts`,
      });
      if (res.status !== 200 || !data.length) return alert("No data found");
      this.docs = data.map(doc => ({
        ...doc,
        date: moment(doc.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      }));
    },
    onProgress(progress) {
      if (progress === 100) {
        this.getDocs();
        return (this.progress = null);
      }
      this.progress = progress;
    },
    async deleteFile(filename, fileId) {
      if (
        !(await confirm(
          `Are you sure you want to delete ${filename || "this resource"}?`
        ))
      )
        return;
      await this.$request({
        url: `${this.BASE_URL}api/files/delete/`,
        query: { file_id: fileId, name: filename },
        method: "DELETE",
      });
      this.getDocs();
    },
  },
};
</script>

<style lang="scss">
.dragdrop {
  .mz-icon-btn {
    color: black;
    background: transparent;
    border-color: #464b4b;
    width: 100px !important;
    border-radius: 4px;
    font-size: 0.9rem;
    padding-top: 5px;
    padding-bottom: 5px;
    svg {
      width: 2em !important;
      height: 2em !important;
    }
  }
}
</style>
